module.exports = __webpack_public_path__ + "static/media/exe.c324fa07.png";